import { render, staticRenderFns } from "./Books.vue?vue&type=template&id=40de69bc"
import script from "./Books.vue?vue&type=script&lang=ts"
export * from "./Books.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports